export default __webpack_public_path__ + "static/media/Layer-4.68855ec3.png";